import React from 'react';
import './index.css'
import DropdownMenu from '../common/DropdownMenu';
import { TicketUpdateFormModel } from '../../models/ticket.model';
import Autocomplete from '../common/Autocomplete';
import { itemSelection } from '../../models/itemSelection.model';

interface NotificationsProps {
  handleSelection?: any
  notificationProfilesList: itemSelection[]
  ticketUpdateForm: TicketUpdateFormModel
}

const Notifications: React.FC<NotificationsProps> = ({handleSelection, notificationProfilesList = [], ticketUpdateForm }) => {

  return (
    <React.Fragment>
      <div className='tkt-form-section'>
        <DropdownMenu label='Notificaciones'>
              <div className='tkt-form-section-item'>
                <Autocomplete
                  label='Perfil'
                  placeholder='Perfil'
                  disabled
                  options={notificationProfilesList}
                  value={ticketUpdateForm.notification_profile}
                  name='notification_profile'
                  handleSelection={handleSelection}
                  required
                />
              </div>
        </DropdownMenu>
      </div>

    </React.Fragment>
  );
}

export default Notifications;
